{"NG_APP_API_URL":"https://dev.api.enjochemagro.com/api/","NG_APP_ENV":"development","NG_APP_WS_URL":"wss://dev.api.enjochemagro.com/ws/"}